module.exports = __webpack_public_path__ + "img/mp.5589a121.png";